<template>
  <div id="CommentsDish">
    <div class="row">
      <div>
        <ul class="collection">
          <li class="collection-item avatar">
            <img src="../../assets/users/people_01.jpg" alt class="circle">
            <span class="title black-text truncate">Jenny Yolanda Orejuela Ortega</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5" checked>
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              4.5
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_02.jpg" alt class="circle">
            <span class="title black-text truncate">Héctor Eduardo Fernández Amaya</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4" checked>
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              3.5
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_03.jpg" alt class="circle">
            <span class="title black-text truncate">Alba Rocío Torres Yepes</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1" checked>
                <label>&#9733;</label>
              </span>
              1
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_04.jpg" alt class="circle">
            <span class="title black-text truncate">Edwar</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5" checked>
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              5
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_05.jpg" alt class="circle">
            <span class="title black-text truncate">Johanna Henao</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2" checked>
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              1.5
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_06.jpg" alt class="circle">
            <span class="title black-text truncate">Elis Daza Escorcia</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4" checked>
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              3.5
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_07.jpg" alt class="circle">
            <span class="title black-text truncate">Sandra Patricia Orejuela Ortega</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1" checked>
                <label>&#9733;</label>
              </span>
              0.5
            </span>
          </li>

          <li class="collection-item avatar">
            <img src="../../assets/users/people_08.jpg" alt class="circle">
            <span class="title black-text truncate">Pablo Mauricio Roncancio Torres</span>
            <p
              class="grey-text"
            >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur et architecto mollitia soluta nobis, doloremque vero molestias id est natus ipsam inventore, corporis laborum debitis labore vel nisi? Itaque, beatae!</p>
            <span class="secondary-content grey-text">
              Calificación:
              <span class="clasificacion">
                <input type="radio" value="5" checked>
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              5
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommentsDish",
  data() {
    return {
      msg: "Comentarios del Plato"
    };
  }
};
</script>

<style scoped>
.circle {
  width: 50px !important;
  height: 50px !important;
}
.collection.with-header .collection-item.avatar {
  padding-left: 110px !important;
}
.collection .collection-item.avatar .title {
  font-size: 14px !important;
}
.collection .collection-item.avatar .grey-text {
  font-size: 12px !important;
}

.collection .collection-item {
  line-height: 1.3rem !important;
  background-color: #f4f4f5 !important;
}
.collection-item.avatar {
  transition: background-color 0.2s;
}

.collection-item.avatar:hover {
  color: #7f0000 !important;
  color: #ffffff !important;
}
.collection-item.avatar:active {
  background-color: #7f0000 !important;
  color: #ffffff !important;
}

.collection .collection-item.avatar .secondary-content {
  top: 0px !important;
  right: 10px !important;
}

ul{
margin-top: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dish/CommentsDish.vue